//Navigation

!function (i) { i.fn.menumaker = function (n) { var e = i(this), s = i.extend({ title: "Menu", format: "language-changer", sticky: !1 }, n); return this.each(function () { return e.find("li ul, li .mega-dropdown").parent().addClass("has-sub"), multiTg = function () { e.find(".has-sub").prepend('<span class="submenu-button"></span>'), e.find(".submenu-button").on("click", function () { $(i(this)).text(($(i(this)).text() == '') ? i(this).next().text() : ''); i(this).toggleClass("submenu-opened"), i(this).parent().toggleClass("parent-active"), i(this).siblings("ul,.mega-dropdown").hasClass("open") ? i(this).siblings("ul,.mega-dropdown").removeClass("open").hide() : i(this).siblings("ul,.mega-dropdown").addClass("open").show() }) }, "multitoggle" === s.format ? multiTg() : e.addClass("language-changer"), s.sticky === !0 && e.css("position", "fixed"), resizeFix = function () { i(window).width() > 1024 && e.find("ul,.mega-dropdown").show(), i(window).width() <= 1024 && e.find("ul,.mega-dropdown").hide().removeClass("open") }, function () { $(window).width() > 1024 ? (resizeFix("resize"), i(window).on(resizeFix)) : (resizeFix(), i(window).on(resizeFix)) } }) } }($), function (i) { i(document).ready(function () { $(".mega-dropdown").parent().addClass("has-mega"), i("#push_sidebar").menumaker({ title: "", format: "multitoggle" }) }) }(jQuery);

// For small screen Nav
jQuery(document).mouseup(function (a) {
    var f = jQuery(a.target).closest(".nav-trigger"), g = jQuery(a.target).closest("#push_sidebar"); f.length ? (a.preventDefault(), jQuery("html").toggleClass('sidebar_active'), jQuery(".nav-trigger").toggleClass("closemenu")) : g.length || (jQuery("html").removeClass('sidebar_active'), jQuery(".nav-trigger").removeClass("closemenu"))
});

// For menu position
function isTouchDevice() { return true == ("ontouchstart" in window || window.DocumentTouch && document instanceof DocumentTouch); } if (isTouchDevice() === true) { } else { jQuery(window).on('load', function () { setTimeout(function () { jQuery("ul.nav > li.has-sub").hover(function () { var s = jQuery("header").offset(), t = jQuery("header").width(), e = s.left + t, i = jQuery(this).find(".submenu-button").siblings("ul").offset(), n = jQuery(this).find(".submenu-button").siblings("ul").width(); e < i.left + n && jQuery(this).addClass("align-left-menu") }, function () { jQuery(this).removeClass("align-left-menu") }), jQuery("ul.nav ul li.has-sub").hover(function () { var s = jQuery("header").offset(), t = jQuery("header").width(), e = s.left, i = e + t, n = jQuery(this).find(".submenu-button").siblings("ul").offset(), l = jQuery(this).find(".submenu-button").siblings("ul").width(), u = n.left; i < u + l && (jQuery(this).addClass("align-left-menu")), e > u && jQuery(this).addClass("align-right-menu") }, function () { jQuery(this).removeClass("align-left-menu"), jQuery(this).removeClass("align-right-menu") }), jQuery(".nav-wrap nav ul.nav ul .has-sub").each(function (iz) { jQuery(this).css("z-index", "500" - iz); }); }, 200); }); }

//Navigation End
$(".mega-dropdown ul > li").mouseenter(function () {
    $(".mega-dropdown ul > li").removeClass("hover-menu")
    $(this).addClass("hover-menu");

});
//Side menu
sidenavFuc = function () {
    $(".side-menu li ul").parent().addClass("has-sub");
    $(".side-menu").find(".has-sub").prepend('<span class="sidemenu-button"></span>');
    $(".sidemenu-button").on("click", function () {
        $(this).toggleClass("submenu-opened"),
            $(this).parent().toggleClass("parent-active")
        $(this).siblings("ul").hasClass("open") ? $(this).siblings("ul").removeClass("open").hide() : $(this).siblings("ul").addClass("open").show();
    });
}
sidenavFuc();

// Header Shrink
$(function () { function b() { return window.pageYOffset || document.documentElement.scrollTop } $(window).scroll(function () { b() >= 1 ? ($("html").addClass("head-fix")) : ($("html").removeClass("head-fix")) }) });
// Header Shrink End

// Background set
$(".bg img").each(function (da) { var db = $(this).attr("src"); $(this).parent().css("background-image", "url(" + db + ")") });

// scroll up
jQuery(window).scroll(function () { jQuery(this).scrollTop() > 0 ? jQuery(".scrollup").addClass("show") : jQuery(".scrollup").removeClass("show") }), jQuery(".scrollup").click(function () { return jQuery("html, body").animate({ scrollTop: 0 }, 500), !1 });

// For Images changes into Background
jQuery(function (t) { var a = function () { t("img.lazy").each(function () { t(this).offset().top - t(window).scrollTop() < t(window).height() && (t(this).attr("src", t(this).attr("data-src")).removeClass("lazy"), t(this).attr("src", t(this).attr("data-src")).addClass("lazyFade"), jQuery(".bg-photo img").each(function (da) { var db = jQuery(this).attr("src"); jQuery(this).parent().parent().parent().parent().addClass("active").css("background-image", "url(" + db + ")") })) }) }; t(function () { a(), t(window).scroll(function () { a() }) }) });

// class adding in image
$(".alignright,.alignleft").closest("p").addClass("pn")

// Table wrap
$("table").wrap("<div class='table-responsive'></div>");

// Lazy load
$(function (a) { var b = function () { a("[data-image]").each(function () { var b = a(this).offset().top, c = a(window).scrollTop(), d = a(window).height(), e = b - c < d; e && (a(this).attr("src", a(this).attr("data-image")).removeClass("lazy"), a(this).attr("src", a(this).attr("data-image")).addClass("lazyFade"), $(".bg-photo img").each(function (da) { var db = $(this).attr("src"); $(this).parent().css("background-image", "url(" + db + ")") })) }) }; a(function () { b(), a(window).scroll(function () { b() }), a(window).on("load", function () { b() }) }) });
//All Function


// footer heading
jQuery('footer h3').click(function () {
    jQuery('footer h3').removeClass('active');
    jQuery(this).parent().siblings('.box').children('.mobile-collapse').slideUp('slow');
    jQuery('footer .mobile-collapse').removeClass('active');
    jQuery(this).addClass('active');
    jQuery(this).next().slideToggle('100').addClass('active');
});

$(".scroll-more").click(function () {
    $("html, body").animate({ scrollTop: $("#scroll-more").offset().top }, 500);
    return true;
});

$('.filter-row ul li').click(function () {
    $(this).children('ul').toggleClass('open');
    $(this).children('a').children('i').toggleClass('fa-minus');
    return false;
})

$('.filter-trigger').click(function () {
    $('.filter-sidebar').toggleClass('open');
    $(this).toggleClass('closemenu');
    return false;
})

$(".sidebar-but").click(function () {
    $(this).toggleClass('active');
    $(".header-bottom-row").toggleClass('active');
    return true;
});

$('.search-trigger').click((event) => {
    event.preventDefault();
    $('.mobile-view.search-sec').toggle();
});

$(document).on('click touchstart', function (event) {
    let click_box = $(".search-trigger, .mobile-view.search-sec");
    if (!click_box.is(event.target) && click_box.has(event.target).length === 0) {
        jQuery(".mobile-view.search-sec").hide();
    }
});

// Filter Accordian
jQuery('.fil-acc-head').click(function () {
    jQuery(this).parent().toggleClass('active');
    jQuery(this).toggleClass('active');
    jQuery(this).next().slideToggle('100').toggleClass('active');
});
// Filter Accordian
jQuery('.pod-acc-head').click(function () {
    jQuery(this).parent().toggleClass('active');
    jQuery(this).toggleClass('active');
    jQuery(this).next().slideToggle('100').toggleClass('active');
});

// Froduct Toggle
$('.fil-toggle input[type="checkbox"]').click(function () {
    if ($(this).is(':checked')) {
        $('.filter-acc').show();
    }
    else {
        $('.filter-acc').hide();
    }
});